export const projects = [
  {
    id: 1,
    name: '3Cat Gamified Experience',
    href: 'https://www.3cat.cat/3cat/',
    category: 'uxui',
    timeline: '4 months',
    client: 'Corporació Catalana de Mitjans Audiovisuals',
    KeyActivities: ["UX Research & Insight Analysis", "Gamification", "High-Fidelity Prototyping", "Usability Testing & Iteration"],
    tinDescription: 'Design a prototype for improving engagement',
    imageSrc: '/imatges/3cat/portada3Cat.png',
    imageAlt: 'Tall slender porcelain bottle with natural clay textured body and cork stopper.',
    contenido: '3cat.js',
  },
  {
    id: 2,
    name: 'BookEcho',
    href: '#',
    category: 'uxui',
    timeline: '4 months',
    client: 'Class project',
    KeyActivities: ["Wireframing", "Userflowing", "React Native Development", "Prototyping", "API Implementation"],
    tinDescription: 'An App to register your readings',
    imageSrc: '/imatges/BookEcho/bookechoCover.png',
    imageAlt: 'Olive drab green insulated bottle with flared screw lid and flat top.',
     contenido: 'bookecho.js',
  },
  /*{
    id: 3,
    name: 'Nuñez i Navarro Maps',
    href: '#',
    category: 'uxui',
    timeline: '3 months',
    client: 'Nuñez i Navarro',
    KeyActivities: ["UX/UI", "Gamification", "Development", "Prototyping"],
    tinDescription: 'Exploring Google Maps Integration in NN pages',
    imageSrc: '/imatges/NN/portadaNN.png',
    imageAlt: 'Person using a pen to cross a task off a productivity paper card.',
     contenido: 'nn.js',
  },*/
  {
    id: 4,
    name: 'Barcimed',
    href: '#',
    category: 'vdxr',
    timeline: '5 months',
    client: 'Final Degree Project',
    KeyActivities: ["UX/UI", "Gamification", "Development", "Prototyping"],
    tinDescription: 'A gamified and immersive experience to discover Medieval Barcelona',
    imageSrc: '/imatges/Barcimed/portadaBarcimed.png',
    imageAlt: 'Hand holding black machined steel mechanical pencil with brass tip and top.',
     contenido: 'barcimed.js',
  },
  {
    id: 5,
    name: 'Masks & Marquises',
    href: '#',
    category: 'vdxr',
    timeline: '4 months',
    client: 'Agència de Patrimoni Cultural de Catalunya',
    KeyActivities: ["UX/UI", "Gamification", "Development", "Prototyping"],
    tinDescription: 'VR videogame inspired in the Moja Palace',
    imageSrc: '/imatges/Giravolt/giravoltCover.png',
    imageAlt: 'Paper card sitting upright in walnut card holder on desk.',
     contenido: 'giravolt.js',
  },
  {
    id: 6,
    name: 'Kitchen Hunt',
    href: '#',
    category: 'vdxr',
    timeline: '4 months',
    client: 'Class project',
    KeyActivities: ["UX/UI", "Gamification", "Development", "Prototyping"],
    tinDescription: 'A kitchen videogame made in Unity',
    imageSrc: '/imatges/KitchenHunt/kitchenhuntv2.png',
    imageAlt: 'Stack of 3 small drab green cardboard paper card refill boxes with white text.',
     contenido: 'kitchenhunt.js',
  },
  /*
  {
    id: 7,
    name: 'Farmàcia Isabel Tell',
    href: '#',
    category: 'other',
    timeline: '4 months',
    client: 'Farmàcia Isabel Tell',
    KeyActivities: ["UX/UI", "Gamification", "Development", "Prototyping"],
    tinDescription: 'Creating the identity of a pharmacy',
    imageSrc: '/imatges/Farmacia/portadaFarmacia.png',
    imageAlt: 'Brass scissors with geometric design, black steel finger holes, and included upright brass stand.',
     contenido: 'farmacia.js',
  },*/
  {
    id: 8,
    name: 'Stranger Things Clock',
    href: '#',
    category: 'other',
    timeline: '2 weeks',
    client: 'Class project',
    KeyActivities: ["Illustration", "2D Animation", "Postproduction"],
    tinDescription: 'Animation inspired in Stragner Things',
    imageSrc: '/imatges/StrangerThings/portadaST.png',
    imageAlt: 'Textured gray felt pouch for paper cards with snap button flap and elastic pen holder loop.',
     contenido: 'strangerthings.js',
  },
    {
    id: 9,
    name: 'Chernobyl Opening',
    href: '#',
    category: 'other',
    timeline: '2 weeks',
    client: 'Class project',
    KeyActivities: ["Compositing", "Motion tracking", "Image editing"],
    tinDescription: 'Chernobyl opening inspired in Narcos opening',
    imageSrc: '/imatges/Chernobyl/chernobylcover.png',
    imageAlt: 'Textured gray felt pouch for paper cards with snap button flap and elastic pen holder loop.',
     contenido: 'chernobyl.js',
  },
]
